const obj_filter_by_key = (o, f) => {

	let n = {}

	o && Object.keys(o).map( k => { if (f(k, o[k])) { n[k] = o[k] } } )

	return n
}

export default obj_filter_by_key